import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { LOGIN_AS_MUTATION } from '../../graphql'
import Spinner from '../Spinner/Spinner'
import { setLocalStorage , extractCustomLoginData, getTenant } from '../../utils'

const LOGIN_AS = gql(LOGIN_AS_MUTATION)

export default function LoginAs() {
  console.log('LoginAs rendered')

  const [searchParams] = useSearchParams()
  const currentParams = Object.fromEntries([...searchParams])
  const navigate = useNavigate()

  useEffect(() => {
    async function loginAs(email, password) {
      try {
        const tenant = getTenant()
        const { data, errors } = await window.apolloClient.mutate({ mutation: LOGIN_AS, variables: { email: email, password: password, tenant: tenant } })
        if (data.loginAs) {
          console.log('LoginAs.useEffect: ', data.loginAs)
          const newLoginData = extractCustomLoginData(data.loginAs)
          setLocalStorage(tenant, JSON.stringify(newLoginData))
          navigate('/home')
        }
        if (errors) {
          console.log(errors)
          navigate('/login')
        }
      } catch(e) {
        
      }
    }
    if (currentParams.email && currentParams.password) {
      loginAs(currentParams.email, currentParams.password)
    } else {
      navigate('/login')
    }
  })

  return <Spinner />
}
